import { Box, Button } from '@mui/material';
import './CompanyProfile.scss';
import userForm from '../../../components/SellerProfile/Form/json/profileFormFields.json';
import SPForm from '../../../components/SellerProfile/Form/SPForm';
import SPFormButton from '../../../components/SellerProfile/Form/SPFormButton';
import { useEffect, useState } from 'react';
import { isEmpty} from '../APIs/Helpers';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { fetchCompanyProfileStart,updateCompanyProfileStart,setCompanySubmitt,setShowSuccessPopUp } from '../../../redux/slices/sellerProfileSlice';
 
function CompanyProfile() {
  const navigate = useNavigate();
  const { i18n, t } = useTranslation();
  let formatFields: any = {};
  const [formathomePgProfileFields, setFormathomePgProfileFields] = useState(
    {}
  );
  const dispatch = useDispatch();
  const {compProfile, defaultCompData,seller_id,updating,compSubmitting,formUpdates} = useSelector((state:any)=>state.sellerProfile)
  const successMsg = t('sellerProfile.dashboard.editCompanyProfileSuccess');
 
  useEffect(()=>{
    if(seller_id){
     // const language = i18n.language ;
      dispatch(fetchCompanyProfileStart({ seller_id,language:i18n.language}));
      try{
        if(defaultCompData){
        getDefaultSettings(defaultCompData);
        }
      }catch(error:any){
        console.log("error")
      }
      }
       // eslint-disable-next-line react-hooks/exhaustive-deps
  },[defaultCompData,i18n.language,seller_id]);


  const getDefaultSettings = (defaultData) => {
    formatFields = {
      ...userForm
    };
    //split up supported and non-suppported pos types
    const supportedPos: string[] = [];
    const nonSupportedPos: string[] = [];
    defaultData?.pos_type?.forEach((item) => {
      //console.log('form')
      let country;
      switch (i18n.language) {
        case 'fr':
          country = item.pays;
          break;
        case 'en':
          country = item.country;
          break;
        default:
          country = item.country;
          break;
      }
      item.support === 'supported' && supportedPos.push(country);
      item.support === 'non-supported' && nonSupportedPos.push(country);
    });

    //console.log(supportedPos,"supportedPos");
    //console.log(nonSupportedPos,"nonsupportedPos");
    //Format data recieved from API to match form fields
     const parentFields = ['api_schema', 'customer_types','business_model'];
    const fieldsToFormat = [
      'api_schema_version',
      'customer_type',
      'business_model_type',
      'pos_type',
      'otherPOS'
    ];
    //traverse through form fields object until find the field we want to format
    const traverse = (obj, field, i) => {
      Object.keys(obj).forEach((key) => {
        if (
          typeof obj[key] === 'object' &&
          obj[key] !== null &&
          key !== field
        ) {
          traverse(obj[key], field, i);
        } else if (obj.hasOwnProperty(field)) {
          let labelArray: string[] = [];
          if (field === 'pos_type' || field === 'otherPOS') {
            labelArray = field === 'pos_type' ? supportedPos : nonSupportedPos;
          } else {
            const translatedFieldName =
              i18n.language === 'fr' &&
                (field === 'customer_type' || field === 'business_model_type')
                ? `${field}_fr`
                : field;
                if(defaultData[parentFields[i]]){
            labelArray = defaultData[parentFields[i]].map(
              (item) =>item[translatedFieldName]
            );
          }
        }
          obj[key]['options'] = labelArray;
        }
      });
    };
   
    fieldsToFormat.forEach((field, i) => {
      traverse(formatFields, field, i);
    });
    //console.log(formatFields, 'formatFields')
    setFormathomePgProfileFields(formatFields);
  };
 
  const submitFormFields = async()=>{
   // const language = i18n.language;
    const santitizedFormUpdates = JSON.parse(JSON.stringify(formUpdates));
    dispatch(updateCompanyProfileStart({formUpdates:santitizedFormUpdates,language:i18n.language}));
  }

  useEffect(()=>{
    if(compSubmitting){
     dispatch(setShowSuccessPopUp(successMsg));
      dispatch(setCompanySubmitt(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[compSubmitting]);
 
  function transformCompProfile(compProfile) {
    if (!compProfile) {
      return {};
    }
    const transformedProfile = {};
    for (const key in compProfile) {
      if (Array.isArray(compProfile[key])) {
        transformedProfile[key] = compProfile[key];
      } else {
        transformedProfile[key] = [compProfile[key]];
      }
    }
    return transformedProfile;
  }

  return !isEmpty(compProfile) &&
    !isEmpty(formathomePgProfileFields) ? (
    <Box className="spUpdateUserProfile">
      <SPForm
        formFields={formathomePgProfileFields}
        formData={transformCompProfile(compProfile)}
        formName="editCompanyProfile"
      />
      <div className="spUpdateButtons">
        <Button
          variant="text"
          onClick={() => {
            navigate(`/${i18n.language}/seller-profile`);
          }}
          className="cancelBtn"
        >
          {t('sellerProfile.dashboard.cancelUpdates')}
        </Button>
        <SPFormButton
          handleClick={() => submitFormFields()}
          label={t('sellerProfile.dashboard.saveUpdates')}
          compName="companyProfile"
          formName="editCompanyProfile"
          key="companyProfile"
          showLoading={updating}
        />
      </div>
    </Box>
  ) : (
    <></>
  );
}
 
export default CompanyProfile;